import workspaceQuery from '../../../graphql/queries/sales/PixSellConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/PixSellConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/PixSellConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/PixSellConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/PixSellConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/PixSellConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const PixSellConfiguration: EntityType = {
  type: 'PixSellConfiguration',
  title: 'PixSell Configurations',
  formTitle: 'PixSell Configuration',
  formUrl: '/Sales/Channel/PixSellConfig/Details/',
  workspaceUrl: '/Sales/Channel/PixSellConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_PIXSELL_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default PixSellConfiguration;
